// eslint-disable-next-line
import util from 'util';

import React from 'react';

import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import * as MuiCore from '@material-ui/core';
import * as PortalApi from './PortalApi';

const styles = theme => ({
  errorMessage : {
    textAlign: 'center',
    color: theme.palette.error.main,
    ...theme.typography.body1,
    fontWeight: 'bold',
  }
});

const Transition = React.forwardRef(function Transition(props, ref) {
  return <MuiCore.Slide direction="up" ref={ref} {...props} />;
});

class Login extends React.Component {
  initialState = {
    open : false,
    saveIdentity : false,
    login : '',
    password: '',
    loggingIn : false,
    loginError : '',
  };

  constructor(props) {
    super(props);
    this.state = this.initialState;
    this.passwordRef = React.createRef();
  }

  /* Clear out the state whenever open toggles */
  componentDidUpdate() {
    if (this.state.open !== this.props.open) {
      this.setState({...this.initialState, open : this.props.open});
    }
  }
  
  tryLogin = () => {
    this.setState({loggingIn: true});
    const { login, password } = this.state;
    PortalApi.post('/api/auth', { login, password }, this.loginSuccess,
                   this.loginError, this.loginError);
  }

  loginSuccess = (status, content) => {
    this.props.onLogin(content.identityKey, content.sessionKey, this.state.saveIdentity);
  }
  
  loginError = (status, content) => {
    this.setState({loggingIn: false, loginError : 'Login or Password Incorrect'});
  }
  
  render() {
    const { classes } = this.props;
    let canSubmit = !this.state.loggingIn && Boolean(this.state.login) && Boolean(this.state.password);
    return (
      <MuiCore.Dialog fullWidth
                      TransitionComponent={Transition}
                      maxWidth='xs' open={this.props.open}
                      className={classes.loginDialog}>
        <MuiCore.DialogTitle>
          <img alt='logo' src={require('./paytrust_logo.svg')} style={{height: 80}}/>
        </MuiCore.DialogTitle>
        <MuiCore.DialogContent>
          <MuiCore.Grid container direction='column' spacing={1} style={{marginTop: 0}}>
            <MuiCore.Grid item>
              <MuiCore.TextField fullWidth
                                 value={this.state.login}
                                 onKeyDown={(event) => {
                                   if (event.key === 'Enter') {
                                     event.preventDefault();
                                     event.stopPropagation();
                                     if (this.passwordRef.current) {
                                       this.passwordRef.current.focus();
                                     }
                                   }
                                 }}

                                 onChange={(event) => this.setState({login: event.target.value})}
                                 label='Login'/>
            </MuiCore.Grid>
            <MuiCore.Grid item>
              <MuiCore.TextField fullWidth
                                 value={this.state.password}
                                 inputRef={this.passwordRef}
                                 onKeyDown={(event) => {
                                   if (event.key === 'Enter') {
                                     event.preventDefault();
                                     event.stopPropagation();
                                     if (canSubmit) {
                                       this.tryLogin();
                                     }
                                   }
                                 }}
                                 onChange={(event) => this.setState({password: event.target.value})}
                                 label='Password' type='password'/>
            </MuiCore.Grid>
            <MuiCore.Grid item>
              <MuiCore.FormControlLabel
                control={
                  <MuiCore.Checkbox checked={this.state.saveIdentity}
                                            onChange={(event) => this.setState({saveIdentity: event.target.checked})}/>
                }
                label="Stay Logged In" />
            </MuiCore.Grid>
          </MuiCore.Grid>
          
          <MuiCore.Hidden xlDown={!Boolean(this.state.loginError)}>
            <div className={classes.errorMessage}>
              {this.state.loginError}
            </div>
          </MuiCore.Hidden>
        </MuiCore.DialogContent>
        <MuiCore.DialogActions>
          <MuiCore.Button disabled={!canSubmit}
                          onClick={this.tryLogin}>
            {this.state.loggingIn ? 'Checking Login...' : 'Login'}
          </MuiCore.Button>
        </MuiCore.DialogActions>
      </MuiCore.Dialog>
    );
  }
}

Login.propTypes = {
  open : PropTypes.bool.isRequired,
  onLogin : PropTypes.func.isRequired,
}

export default withStyles(styles)(Login);

